import { qualitySteps, qualityKPIs } from '@/mocks/homeData';

export default function QualityAssurance() {
  return (
    <section id="quality" className="py-20 md:py-28 bg-white">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16 items-start">
          <div className="animate-on-scroll">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
              Quality Assurance
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-4 leading-tight">
              Quality That Meets<br />Global Standards
            </h2>
            <p className="text-foreground-500 leading-relaxed mb-8 max-w-[500px]">
              Our multi-stage quality assurance system ensures every garment meets international buyer specifications — from raw material to final shipment.
            </p>

            <img
              src="https://readdy.ai/api/search-image?query=Professional%20textile%20quality%20testing%20laboratory%20with%20modern%20equipment%2C%20color%20matching%20cabinets%2C%20fabric%20testing%20machines%2C%20bright%20clean%20environment%2C%20white%20walls%20and%20surfaces%2C%20professional%20atmosphere%2C%20scientific%20precision%2C%20industrial%20laboratory%20photography&width=700&height=500&seq=quality-lab-01&orientation=landscape"
              alt="Quality testing laboratory"
              className="w-full rounded-lg object-cover aspect-[7/5]"
            />

            {/* <div className="grid grid-cols-2 gap-4 mt-8">
              {qualityKPIs.map((kpi, i) => (
                <div key={i} className="bg-[#F7F9FC] rounded-lg p-5">
                  <div className="text-2xl font-heading font-bold text-primary-500 mb-1">{kpi.value}%</div>
                  <div className="text-xs text-foreground-500">{kpi.label}</div>
                </div>
              ))}
            </div> */}
          </div>

          <div className="animate-on-scroll animate-on-scroll-delay-2">
            <div className="space-y-0">
              {qualitySteps.map((step, i) => (
                <div key={i} className="flex gap-5 pb-8 last:pb-0 relative">
                  {i < qualitySteps.length - 1 && (
                    <div className="absolute left-[19px] top-12 bottom-0 w-px bg-[#E6EAF0]"></div>
                  )}
                  <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center font-heading font-semibold text-xs">
                    {i + 1}
                  </div>
                  <div className="pt-1.5">
                    <div className="text-[11px] text-accent-400 font-medium uppercase tracking-wider mb-1">{step.phase}</div>
                    <h3 className="text-base font-heading font-semibold text-foreground-800 mb-2">{step.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}